import Shared from './AppScript.js';

export default {
  ...Shared,

  methods: {
    ...Shared.methods,

    getEndpoint() {
      return `daily-solution`
    },
  }
};
